import React__default, { useContext, createContext, useReducer, createElement, Fragment, useState, forwardRef } from 'react';
import produce from 'immer';
import styled from '@emotion/styled';
import { styles, MuiButton, SvgTag, SvgGift, SvgRewards, SvgDelete, ReactMuiMask, SvgClose, SvgPlus, SvgDollar, SvgRight } from '@onehope/design-system-ohw';
import { DateTime } from 'luxon';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import _orderBy from 'lodash-es/orderBy';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTablePagination from '@material-ui/core/TablePagination';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiSortIcon from '@material-ui/icons/ImportExport';
import { useQuery } from '@apollo/react-hooks';
import MuiDialog from '@material-ui/core/Dialog';
import MuiIconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles, useTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'regenerator-runtime/runtime';
import gql from 'graphql-tag';
import SlickCarousel from 'react-slick';
import Fade from '@material-ui/core/Fade';
import { Formik, Form } from 'formik';
import { object, string } from 'yup';
import { isEmpty } from 'lodash-es';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { Currency, styles as styles$1 } from '@onehope/design-system';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Slide from '@material-ui/core/Slide';

var CustomerRewardsNetworkLayerContext = /*#__PURE__*/createContext();
var useCustomerRewardsNetworkLayerValue = function useCustomerRewardsNetworkLayerValue() {
  return useContext(CustomerRewardsNetworkLayerContext);
};
function CustomerRewardsNetworkLayer(_ref) {
  var children = _ref.children,
      viewer = _ref.viewer,
      shopUrl = _ref.shopUrl,
      apolloClient = _ref.apolloClient,
      handlePointsRedeem = _ref.handlePointsRedeem,
      pointsRedeemMutationLoading = _ref.pointsRedeemMutationLoading;
  return React__default.createElement(CustomerRewardsNetworkLayerContext.Provider, {
    value: {
      viewer: viewer,
      shopUrl: shopUrl,
      apolloClient: apolloClient,
      handlePointsRedeem: handlePointsRedeem,
      pointsRedeemMutationLoading: pointsRedeemMutationLoading
    }
  }, children);
}

var TypeKeys;

(function (TypeKeys) {
  TypeKeys["UPDATE_USER"] = "UPDATE_USER";
})(TypeKeys || (TypeKeys = {}));

function reducer(state, action) {
  return produce(state, function (draft) {
    switch (action.type) {
      case TypeKeys.UPDATE_USER:
        var user = action.user;
        draft.user = user;
        break;
    }
  });
}

var CustomerRewardsContext = /*#__PURE__*/createContext();
function CustomerRewardsProvider(_ref) {
  var children = _ref.children;
  var initialState = {}; // @ts-ignore

  var sync = useReducer(reducer, initialState);
  return React__default.createElement(CustomerRewardsContext.Provider, {
    value: sync
  }, children);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function Diamond() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    fill: "none",
    viewBox: "0 0 40 40"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M20.735 9h-1.127v4.3h1.127V9zM29.3 21.074a.604.604 0 01-.098.69l-8.648 9.022a.555.555 0 01-.873 0l-8.642-9.023a.604.604 0 01-.099-.683l2.86-5.613a.56.56 0 01.498-.311h11.645c.208 0 .4.119.498.31l2.86 5.608zm-9.18 7.8l2.772-6.938-5.527.006 2.755 6.933zm-2.324-8.11l2.324-3.811 2.324 3.81h-4.648zm9.648 1.172h-3.332l-2.386 5.983 5.718-5.983zm-2.862-1.172l1.454-3.606 1.83 3.611-3.284-.005zm-3.504-4.436l2.448 4.028 1.611-4.028h-4.059zm-4.338 4.005l-1.6-4.005h4.023l-2.423 4.005zm-4.366.434h3.321l-1.462-3.65-1.86 3.65zm3.786 1.172l2.355 5.98-5.719-5.977 3.364-.003zm12.165-6.733l2.922-2.922.829.829-2.922 2.922-.83-.83zM8.797 12.24L8 13.037l3.04 3.041.798-.796-3.041-3.041z",
    clipRule: "evenodd"
  })));
}

function Money() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "27",
    fill: "none",
    viewBox: "0 0 30 27"
  }, React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M17.336 24.882c-.398 0-.798-.02-1.2-.06l.217-2.143a9.937 9.937 0 009.458-4.715c2.824-4.662 1.328-10.752-3.333-13.575A9.825 9.825 0 0015 3.245a9.826 9.826 0 00-6.098 4.478 9.784 9.784 0 00-1.404 4.384l-2.147-.158a11.909 11.909 0 011.71-5.341 11.954 11.954 0 017.424-5.455 11.962 11.962 0 019.107 1.394 11.953 11.953 0 015.455 7.425 11.956 11.956 0 01-1.393 9.107c-2.187 3.61-6.145 5.803-10.318 5.803z",
    clipRule: "evenodd"
  }), React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M12.351 23.41l4.862-2.418-.338 5.419-4.524-3.001zm6.151-6.567v1.214l-1.733.06v-1.111c-1.009-.06-1.955-.386-2.697-.785l.74-1.63c.757.355 1.557.593 2.297.593.962 0 1.362-.46 1.362-.949 0-.533-.651-.77-1.437-1.051-1.14-.4-2.548-.904-2.548-2.563 0-1.17.697-2.37 2.327-2.74v-.979l1.733-.058v.977a6.728 6.728 0 012.103.592l-.622 1.616c-.696-.327-1.466-.52-2.06-.52-.828 0-1.198.43-1.198.904 0 .505.428.786 1.007 1.023 1.214.488 3.125.785 3.125 2.592 0 1.288-.918 2.4-2.399 2.815zm-16.76 3.28a5.111 5.111 0 014.519-5.85 5.083 5.083 0 011.893.158 4.816 4.816 0 00-3.195-.791 4.865 4.865 0 00-4.334 5.332 4.852 4.852 0 002.183 3.567 5.058 5.058 0 01-1.066-2.415z",
    clipRule: "evenodd"
  }), React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M10.673 22a4.064 4.064 0 01-6.218.415 4.059 4.059 0 01.467-6.043 4.072 4.072 0 013.474-.712c.252.065.494.152.724.261A4.064 4.064 0 0110.673 22zm-.078-6.046a4.855 4.855 0 00-2.638-1.179l-.084-.007a4.828 4.828 0 00-3.288.87 4.852 4.852 0 00-.295 7.7 4.833 4.833 0 003.023 1.12 4.865 4.865 0 004.936-4.78 4.848 4.848 0 00-1.654-3.723",
    clipRule: "evenodd"
  }), React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M7.33 19.821l-.165.017-.159-1.534c.065-.012.124-.018.183-.024.508-.053.84.11.897.652.05.49-.195.832-.755.89H7.33zM7.024 17.6a8.436 8.436 0 00-.967.17l.427 4.132.885-.091-.135-1.3.125-.012c.938-.097 1.734-.59 1.619-1.706-.107-1.027-.892-1.303-1.955-1.193",
    clipRule: "evenodd"
  }));
}

function Redeem() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "24",
    fill: "none",
    viewBox: "0 0 28 24"
  }, React__default.createElement("path", {
    fill: "#393939",
    d: "M13.354 10.071a.555.555 0 00-.555.555v.732c-.052.01-.107.014-.156.029a1.611 1.611 0 00-1.15 1.704c.134 1 1.026 1.311 1.677 1.54.277.073.539.197.772.364a.514.514 0 01.174.38.502.502 0 01-.182.371.996.996 0 01-.626.227c-.29.006-.58-.02-.864-.077a2.351 2.351 0 01-.228-.052.554.554 0 10-.32 1.063c.115.032.232.06.35.08.2.037.38.06.553.077v.686a.555.555 0 001.11 0v-.769c.284-.076.546-.216.768-.41a1.592 1.592 0 00.03-2.38 3.096 3.096 0 00-1.17-.608c-.626-.22-.904-.346-.944-.64a.501.501 0 01.364-.492 1.948 1.948 0 011.185.117.555.555 0 10.41-1.032 3.462 3.462 0 00-.644-.18v-.73a.555.555 0 00-.554-.555zM27.71 3.552a4.537 4.537 0 00-1.063-2.226A3.987 3.987 0 0023.57.001h-.155a4.106 4.106 0 00-2.731 1.073 4.201 4.201 0 00-.598-.439 4.504 4.504 0 00-2.731-.594 3.956 3.956 0 00-2.772 1.499 4.815 4.815 0 00-1.01 3.086 5.412 5.412 0 00.92 2.81c.576.85 1.274 1.611 2.072 2.26 1.066.92 2.23 1.72 3.468 2.39.194.107.412.163.633.164.229-.002.452-.062.651-.173a19.836 19.836 0 003.23-2.201 11.298 11.298 0 002.318-2.503 4.993 4.993 0 00.845-3.821zM26.154 22.89H.554a.555.555 0 100 1.11h25.6a.555.555 0 000-1.11z"
  }), React__default.createElement("path", {
    fill: "#393939",
    d: "M7.554 21.398a.555.555 0 00.41-.93 7.533 7.533 0 01-1.968-5.023 7.354 7.354 0 016.934-7.342.555.555 0 10-.063-1.108 8.464 8.464 0 00-7.98 8.45 8.655 8.655 0 002.258 5.773.554.554 0 00.409.18zM18.782 21.252a.553.553 0 00.784-.034 8.536 8.536 0 002.254-5.773c0-.643-.073-1.284-.218-1.91a.555.555 0 00-1.081.252 7.3 7.3 0 01.19 1.658 7.429 7.429 0 01-1.963 5.023.554.554 0 00.034.784z"
  }));
}

function WineToast() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30"
  }, React__default.createElement("path", {
    fill: "#393939",
    fillRule: "evenodd",
    d: "M19.488 6.18a.626.626 0 01-.882 0 .603.603 0 010-.868l1.948-1.94a.65.65 0 01.903 0c.246.243.246.647 0 .869l-1.969 1.94zm-7.424-2.02c.143.323.02.687-.308.828a.64.64 0 01-.84-.303l-1.17-2.464a.633.633 0 01.308-.829.65.65 0 01.84.303l1.17 2.465zm4.04-.141a.631.631 0 01-.738.505c-.329-.06-.575-.384-.513-.707l.492-2.708c.062-.323.39-.545.718-.505.349.061.574.384.513.728l-.472 2.687zm-.451 5.535l10.193-2.707c.349-.08.697.121.78.445l1.517 5.535a6.34 6.34 0 01-.656 4.829 6.483 6.483 0 01-3.323 2.768l1.846 6.747 2.605-.687a.618.618 0 01.759.445.595.595 0 01-.431.747l-6.44 1.697a.606.606 0 01-.759-.424.607.607 0 01.43-.768l2.626-.686-1.846-6.748a6.562 6.562 0 01-4.266-.768c-1.435-.828-2.563-2.162-3.015-3.859l-.902-3.313-.43 1.616a6.375 6.375 0 01-3.016 3.839 6.4 6.4 0 01-4.286.767l-1.825 6.748 2.604.687c.328.101.533.445.451.768a.656.656 0 01-.779.444L1.07 25.98a.627.627 0 01-.45-.767c.081-.324.43-.526.779-.445l2.604.707 1.826-6.747c-1.436-.546-2.584-1.536-3.302-2.789a6.212 6.212 0 01-.657-4.808l1.498-5.556c.102-.323.45-.525.779-.424l11.24 2.97c.348.08.553.424.45.747l-.184.687zm6.747 4.223c.964 0 1.826-.04 2.605-.243a4.922 4.922 0 001.805-.788l-1.23-4.525-10.05 2.646.78 2.788c1.517-.12 2.85-.04 4.1.04.698.041 1.355.082 1.99.082zm-8.696-1.819c-1.538-.141-2.85-.06-4.122.02-.677.041-1.354.082-1.99.082-.943 0-1.804-.04-2.584-.223a5.703 5.703 0 01-1.804-.788l1.23-4.545 10.03 2.646-.76 2.808z",
    clipRule: "evenodd"
  }));
}

function numberWithCommas(x) {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
}

function createRowData(item) {
  if (item) {
    var id = item.id,
        created_at = item.created_at,
        points = item.points,
        total_points = item.total_points,
        action = item.action;
    var dateFormatted = created_at ? DateTime.fromISO(created_at).toLocaleString(DateTime.DATE_FULL) : created_at;
    return {
      id: id,
      date: dateFormatted,
      action: action,
      pointsChange: points,
      totalPoints: total_points
    };
  }

  return {
    id: null,
    date: null,
    action: null,
    pointsChange: null,
    totalPoints: null
  };
}

function getRows(historyItems) {
  return historyItems === null || historyItems === void 0 ? void 0 : historyItems.map(function (item) {
    return createRowData(item === null || item === void 0 ? void 0 : item.node);
  });
}
function getPointDollarAmount(pointBalance) {
  return pointBalance ? pointBalance / 100 : 0;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  //min-height: 40px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.01em;\n  text-align: center;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: ", ";\n  padding-bottom: 8px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 30px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  line-height: 24px;\n  margin-left: 16px;\n  @media all and (min-width: 768px) {\n    max-width: 264px;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-bottom: 16px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 24px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  padding-top: 24px;\n  @media all and (min-width: 768px) {\n    padding-top: 0px;\n    max-width: 320px;\n    margin-left: 24px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media all and (min-width: 768px) {\n    max-width: 320px;\n    margin-right: 24px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  //align-items:  center;\n  @media all and (min-width: 768px) {\n    justify-content: space-between;\n    flex-direction: row;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 32px;\n  line-height: 47px;\n  text-align: center;\n  letter-spacing: 0.03em;\n  @media all and (min-width: 768px) {\n    padding-bottom: 24px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  font-family: ", ";\n  color: ", ";\n  padding: 16px;\n  @media all and (min-width: 768px) {\n    padding: 24px 40px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  background: white;\n  padding: 24px 16px 40px 16px;\n  @media all and (min-width: 1024px) {\n    padding: 0 0 64px 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants = styles.cssConstants,
    black2 = _s$cssConstants.black2,
    neutral100 = _s$cssConstants.neutral100,
    lightBlue = _s$cssConstants.lightBlue,
    italicFont = _s$cssConstants.italicFont,
    tertiaryFont = _s$cssConstants.tertiaryFont;
var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject());
var Container = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2(), lightBlue, tertiaryFont, black2);
var Header = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3(), italicFont);
var SummaryContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4());
var PointsContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5());
var BenefitsContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6());
var ListItemContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7());
var ListItemText = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8());
var PointsAmount = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9());
var PointsText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject10());
var PointDollarAmount = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject11(), neutral100);
var PointsDescription = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject12());
var SvgIcon = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject13()); // @ts-ignore

function RewardsSummary(props) {
  var pointBalance = props.pointBalance;
  var pointDollarAmount = getPointDollarAmount(pointBalance);
  return createElement(Wrapper, null, createElement(Container, null, createElement(Header, null, "Your Rewards Summary"), createElement(SummaryContainer, null, createElement(PointsContainer, null, createElement(Diamond, null), createElement(PointsAmount, null, numberWithCommas(pointBalance) || 0, ' ', createElement(PointsText, null, "points")), createElement(PointDollarAmount, null, "($", pointDollarAmount.toFixed(2), ")"), createElement(PointsDescription, null, "100 points equals $1 in credit. Keep shopping to get rewards, benefits, and discounts!")), createElement(BenefitsContainer, null, createElement(ListItemContainer, null, createElement(SvgIcon, null, createElement(Money, null)), createElement(ListItemText, null, "Earn 5 points per dollar spent, and 10 points per dollar when you subscribe.")), createElement(ListItemContainer, null, createElement(SvgIcon, null, createElement(WineToast, null)), createElement(ListItemText, null, "Host a wine fundraiser and earn 10 points per dollar in purchases made at your event.")), createElement(ListItemContainer, null, createElement(SvgIcon, null, createElement(Redeem, null)), createElement(ListItemText, null, "Redeem your reward points to save on future purchases, or donate them to make an impact."))))));
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.01em;\n  font-family: ", ";\n  color: ", ";\n  text-align: left;\n  padding: 0 16px;\n  @media all and (min-width: 1024px) {\n    padding: 0;\n  }\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    padding-left: 20px;\n    :hover {\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableContainer-root {\n    max-height: 640px;\n    width: 100%;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableCell-root {\n    font-weight: normal;\n    color: ", ";\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n    font-family: ", ";\n    padding: 24px 16px;\n    border-bottom: 1px solid ", ";\n  }\n  &.MuiTableCell-head {\n    background-color: ", ";\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 11px;\n    line-height: 16px;\n    letter-spacing: 0.15em;\n    border-bottom: none;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTablePagination-root {\n    padding: 12px 0;\n  }\n  .MuiTablePagination-caption,\n  .MuiTablePagination-input {\n    font-weight: normal;\n    color: ", ";\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n    font-family: ", ";\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableRow-root {\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableHead-root {\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTable-root {\n    padding: 0 16px;\n    @media all and (min-width: 1024px) {\n      padding: 0;\n    }\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$1 = styles.cssConstants,
    tertiaryFont$1 = _s$cssConstants$1.tertiaryFont,
    bronzeNeutral0 = _s$cssConstants$1.bronzeNeutral0,
    neutral2 = _s$cssConstants$1.neutral2,
    neutral5 = _s$cssConstants$1.neutral5,
    black2$1 = _s$cssConstants$1.black2;
var Paper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1());
var Table = /*#__PURE__*/styled(MuiTable)( /*#__PURE__*/_templateObject2$1());
var TableHead = /*#__PURE__*/styled(MuiTableHead)( /*#__PURE__*/_templateObject3$1());
var TableRow = /*#__PURE__*/styled(MuiTableRow)( /*#__PURE__*/_templateObject4$1(), neutral2);
var TablePagination = /*#__PURE__*/styled(MuiTablePagination)( /*#__PURE__*/_templateObject5$1(), black2$1, tertiaryFont$1);
var TableCell = /*#__PURE__*/styled(MuiTableCell)( /*#__PURE__*/_templateObject6$1(), black2$1, tertiaryFont$1, neutral5, neutral2);
var TableContainer = /*#__PURE__*/styled(MuiTableContainer)( /*#__PURE__*/_templateObject7$1());
var TableBody = /*#__PURE__*/styled(MuiTableBody)( /*#__PURE__*/_templateObject8$1());
var SortIcon = /*#__PURE__*/styled(MuiSortIcon)( /*#__PURE__*/_templateObject9$1());
var HeaderCellWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject10$1());
var PointsNotification = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject11$1(), tertiaryFont$1, black2$1);
var columns = [{
  id: 'date',
  align: 'left',
  minWidth: 140,
  label: 'Date',
  sort: true
}, {
  id: 'action',
  align: 'left',
  color: bronzeNeutral0,
  fontWeight: 500,
  label: 'Action',
  minWidth: 100
}, {
  id: 'pointsChange',
  label: 'Point Change',
  align: 'center',
  minWidth: 101,
  format: function format(value) {
    return numberWithCommas(value);
  }
}, {
  id: 'totalPoints',
  label: 'Total Points',
  align: 'center',
  fontWeight: 'bold',
  minWidth: 101,
  format: function format(value) {
    return numberWithCommas(value);
  }
}];
function sortByDate(historyItems, sortDirection) {
  if (historyItems) {
    if (sortDirection) {
      return _orderBy(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges, [function (e) {
        var _e$node;

        return e === null || e === void 0 ? void 0 : (_e$node = e.node) === null || _e$node === void 0 ? void 0 : _e$node.created_at;
      }]);
    } else {
      return _orderBy(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges, [function (e) {
        var _e$node2;

        return e === null || e === void 0 ? void 0 : (_e$node2 = e.node) === null || _e$node2 === void 0 ? void 0 : _e$node2.created_at;
      }], ['desc']);
    }
  }

  return historyItems;
}
function StickyHeadTable(props) {
  // @ts-ignore
  var historyItems = props.historyItems;

  var _React$useState = React__default.useState(false),
      isMounted = _React$useState[0],
      setMounted = _React$useState[1];

  React__default.useEffect(function () {
    setMounted(true);
  }, []);
  React__default.useEffect(function () {
    if (isMounted) {
      setRows(getRows(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges) || []);
    }
  }, [props.historyItems]);

  var _React$useState2 = React__default.useState(0),
      page = _React$useState2[0],
      setPage = _React$useState2[1];

  var _React$useState3 = React__default.useState(6),
      rowsPerPage = _React$useState3[0],
      setRowsPerPage = _React$useState3[1];

  var _React$useState4 = React__default.useState(true),
      sortDirection = _React$useState4[0],
      setSortDirection = _React$useState4[1];

  var _React$useState5 = React__default.useState(getRows(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges) || []),
      rows = _React$useState5[0],
      setRows = _React$useState5[1];

  var handleChangePage = function handleChangePage(_event, newPage) {
    setPage(newPage);
  };

  var handleSortByDate = function handleSortByDate() {
    var sortedRows = sortByDate(historyItems, sortDirection);
    setSortDirection(!sortDirection); // @ts-ignore

    setRows(getRows(sortedRows) || []);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return React__default.createElement(Paper, null, React__default.createElement(TableContainer, null, React__default.createElement(Table, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, columns.map(function (column) {
    return React__default.createElement(TableCell, {
      key: column.id,
      align: column.align,
      style: {
        minWidth: column.minWidth
      }
    }, React__default.createElement(HeaderCellWrapper, null, column.label, column.sort && React__default.createElement(SortIcon, {
      onClick: handleSortByDate
    })));
  }))), React__default.createElement(TableBody, null, rows === null || rows === void 0 ? void 0 : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
    return React__default.createElement(TableRow, {
      hover: true,
      role: "checkbox",
      tabIndex: -1,
      key: "" + row.id
    }, columns.map(function (column) {
      var value = row[column.id];
      return React__default.createElement(TableCell, {
        key: column.id,
        align: column.align,
        style: {
          color: column.color,
          fontWeight: column.fontWeight
        }
      }, column.format && typeof value === 'number' ? column.format(value) : value);
    }));
  })))), React__default.createElement(TablePagination, {
    page: page,
    rowsPerPageOptions: [6],
    component: "div",
    count: rows === null || rows === void 0 ? void 0 : rows.length,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), React__default.createElement(PointsNotification, null, "Don\u2019t see your points yet? Your activity will update within 24 hours."));
}

function _templateObject11$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.01em;\n  font-family: ", ";\n  color: ", ";\n"]);

  _templateObject11$2 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n  color: ", ";\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableContainer-root {\n    //max-height: 640px;\n    width: 100%;\n  }\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableCell-root {\n    font-weight: normal;\n    color: ", ";\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n    font-family: ", ";\n    padding: 16px 6px !important;\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n  }\n  &.MuiTableCell-head {\n    background-color: ", ";\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 11px;\n    line-height: 16px;\n    letter-spacing: 0.15em;\n    border-bottom: none;\n    text-wrap: normal;\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    white-space: normal !important;\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTablePagination-root {\n    padding: 12px 0;\n  }\n  .MuiTablePagination-caption,\n  .MuiTablePagination-input {\n    font-weight: normal;\n    color: ", ";\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n    font-family: ", ";\n  }\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableRow-root {\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTableHead-root {\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiTable-root {\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: calc(100% - 32px);\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$2 = styles.cssConstants,
    tertiaryFont$2 = _s$cssConstants$2.tertiaryFont,
    bronzeNeutral0$1 = _s$cssConstants$2.bronzeNeutral0,
    neutral2$1 = _s$cssConstants$2.neutral2,
    neutral5$1 = _s$cssConstants$2.neutral5,
    black2$2 = _s$cssConstants$2.black2;
var Paper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$2());
var Table$1 = /*#__PURE__*/styled(MuiTable)( /*#__PURE__*/_templateObject2$2());
var TableHead$1 = /*#__PURE__*/styled(MuiTableHead)( /*#__PURE__*/_templateObject3$2());
var TableRow$1 = /*#__PURE__*/styled(MuiTableRow)( /*#__PURE__*/_templateObject4$2(), neutral2$1);
var TablePagination$1 = /*#__PURE__*/styled(MuiTablePagination)( /*#__PURE__*/_templateObject5$2(), black2$2, tertiaryFont$2);
var TableCell$1 = /*#__PURE__*/styled(MuiTableCell)( /*#__PURE__*/_templateObject6$2(), black2$2, tertiaryFont$2, neutral5$1, neutral5$1, neutral2$1, neutral5$1, neutral5$1);
var TableContainer$1 = /*#__PURE__*/styled(MuiTableContainer)( /*#__PURE__*/_templateObject7$2());
var TableBody$1 = /*#__PURE__*/styled(MuiTableBody)( /*#__PURE__*/_templateObject8$2());
var HeaderCellWrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9$2());
var Action = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject10$2(), bronzeNeutral0$1);
var PointsNotification$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject11$2(), tertiaryFont$2, black2$2);
var columns$1 = [{
  id: 'date',
  maxWidth: 142,
  minWidth: 142,
  align: 'left',
  label: 'Date & Activity',
  backgroundColor: 'white',
  render: function render(_ref) {
    var date = _ref.date,
        action = _ref.action;
    return React__default.createElement("div", null, React__default.createElement("div", null, date), React__default.createElement(Action, null, action));
  }
}, {
  id: 'pointsChange',
  label: 'Point Change',
  align: 'center',
  maxWidth: 69,
  backgroundColor: neutral2$1,
  format: function format(value) {
    return numberWithCommas(value);
  }
}, {
  id: 'totalPoints',
  label: 'Total Points',
  align: 'center',
  maxWidth: 69,
  fontWeight: 'bold',
  backgroundColor: neutral2$1,
  format: function format(value) {
    return numberWithCommas(value);
  }
}];
function MobileTable(props) {
  // @ts-ignore
  var historyItems = props.historyItems;

  var _React$useState = React__default.useState(false),
      isMounted = _React$useState[0],
      setMounted = _React$useState[1];

  var _React$useState2 = React__default.useState(0),
      page = _React$useState2[0],
      setPage = _React$useState2[1];

  var _React$useState3 = React__default.useState(6),
      rowsPerPage = _React$useState3[0],
      setRowsPerPage = _React$useState3[1];

  var _React$useState4 = React__default.useState(getRows(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges) || []),
      rows = _React$useState4[0],
      setRows = _React$useState4[1];

  React__default.useEffect(function () {
    setMounted(true);
  }, []);
  React__default.useEffect(function () {
    if (isMounted) {
      setRows(getRows(historyItems === null || historyItems === void 0 ? void 0 : historyItems.edges) || []);
    }
  }, [props.historyItems]);

  var handleChangePage = function handleChangePage(_event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return React__default.createElement(Paper$1, null, React__default.createElement(TableContainer$1, null, React__default.createElement(Table$1, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, React__default.createElement(TableHead$1, null, React__default.createElement(TableRow$1, null, columns$1.map(function (column) {
    return React__default.createElement(TableCell$1, {
      key: column.id,
      align: column.align,
      style: {
        maxWidth: column.maxWidth,
        minWidth: column.minWidth,
        backgroundColor: column.backgroundColor
      }
    }, React__default.createElement(HeaderCellWrapper$1, null, column.label));
  }))), React__default.createElement(TableBody$1, null, rows === null || rows === void 0 ? void 0 : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row, index) {
    return React__default.createElement(TableRow$1, {
      hover: true,
      tabIndex: -1,
      key: "" + row.id + index
    }, columns$1.map(function (column) {
      var value = row[column.id];
      return React__default.createElement(TableCell$1, {
        key: column.id,
        align: column.align,
        style: {
          color: column.color,
          maxWidth: column.maxWidth,
          fontWeight: column.fontWeight,
          backgroundColor: column.backgroundColor
        }
      }, column.render ? column.render({
        date: row['date'],
        action: row['action']
      }) : column.format && typeof value === 'number' ? column.format(value) : value);
    }));
  })))), React__default.createElement(TablePagination$1, {
    page: page,
    rowsPerPageOptions: [6],
    component: "div",
    count: rows === null || rows === void 0 ? void 0 : rows.length,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), React__default.createElement(PointsNotification$1, null, "Don\u2019t see your points yet? Your activity will update within 24 hours."));
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    width: 288px;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  line-height: 24px;\n  /* or 150% */\n  font-family: ", ";\n  text-align: center;\n  letter-spacing: 0.01em;\n  padding-bottom: 32px;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 16px;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var tertiaryFont$3 = styles.cssConstants.tertiaryFont;
var Wrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$3());
var Summary = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$3(), tertiaryFont$3);
var StartShoppingButton = /*#__PURE__*/styled(MuiButton)( /*#__PURE__*/_templateObject3$3());
function NoPointsActivity() {
  var _useCustomerRewardsNe = useCustomerRewardsNetworkLayerValue(),
      shopUrl = _useCustomerRewardsNe.shopUrl;

  var handleStartShopping = function handleStartShopping() {
    window.location.href = "" + shopUrl;
  };

  return createElement(Wrapper$1, null, createElement(Summary, null, "Once you start earning reward points, all of your point activity will appear here to help you keep track of your earnings and redemptions."), createElement(StartShoppingButton, {
    onClick: handleStartShopping,
    type: "SECONDARY"
  }, "Start Shopping"));
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 32px;\n  line-height: 47px;\n  text-align: center;\n  letter-spacing: 0.03em;\n  padding-bottom: 16px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 32px;\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  background: white;\n  padding-bottom: 40px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 64px;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var italicFont$1 = styles.cssConstants.italicFont;
var Wrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$4());
var Container$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$4());
var Header$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$4(), italicFont$1);
function PointsActivityTable(props) {
  var _historyItems$edges;

  var historyItems = props.historyItems;
  var isMobile = useMediaQuery('(max-width:767px)', {
    noSsr: true
  });
  var hasActivity = !!(historyItems === null || historyItems === void 0 ? void 0 : (_historyItems$edges = historyItems.edges) === null || _historyItems$edges === void 0 ? void 0 : _historyItems$edges.length);
  return createElement(Wrapper$2, null, createElement(Container$1, null, createElement(Header$1, null, "Points Activity"), hasActivity ? createElement(Fragment, null, isMobile ? createElement(MobileTable, {
    historyItems: historyItems
  }) : createElement(StickyHeadTable, {
    historyItems: historyItems
  })) : createElement(NoPointsActivity, null)));
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 8px;\n  font-weight: bold;\n  font-size: 11px;\n  text-align: center;\n  letter-spacing: 0.15em;\n  color: ", ";\n  font-family: ", ";\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiCircularProgress-colorPrimary {\n    color: white;\n  }\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$3() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    max-width: 256px !important;\n    @media all and (min-width: 768px) {\n      max-width: 288px !important;\n    }\n  }\n"]);

  _templateObject11$3 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  text-align: center;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  margin: 8px 0;\n"]);

  _templateObject10$3 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  margin: 0 0 40px 0;\n  width: 232px;\n"]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 232px;\n  height: 232px;\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: ", ";\n  color: ", ";\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  color: ", ";\n  padding-bottom: 40px;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 32px;\n  line-height: 47px;\n  text-align: center;\n  letter-spacing: 0.03em;\n  font-family: ", ";\n  padding-bottom: 16px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 16px 40px 16px;\n  font-family: ", ";\n  color: ", ";\n  @media all and (min-width: 768px) {\n    padding: 20px 80px 80px 80px;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$3 = styles.cssConstants,
    tertiaryFont$4 = _s$cssConstants$3.tertiaryFont,
    italicFont$2 = _s$cssConstants$3.italicFont,
    black2$3 = _s$cssConstants$3.black2,
    redText = _s$cssConstants$3.redText;
var StyledDialog = /*#__PURE__*/withStyles({
  root: {
    textAlign: 'center',
    zIndex: "10002 !important"
  },
  paper: {
    maxWidth: '654px',
    borderRadius: '2px'
  },
  paperScrollPaper: {
    maxHeight: '100vh'
  }
})(MuiDialog);
var Content = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$5(), tertiaryFont$4, black2$3);
var Header$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$5(), italicFont$2);
var Summary$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$5(), black2$3);
var Dialog = /*#__PURE__*/styled(StyledDialog)( /*#__PURE__*/_templateObject4$3(), tertiaryFont$4);
var CloseButtonContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$3());
var IconButton = /*#__PURE__*/styled(MuiIconButton)( /*#__PURE__*/_templateObject6$3());
var Container$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$3(), tertiaryFont$4, black2$3);
var Logo = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject8$3());
var Description = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9$3());
var PointsNeeded = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject10$3());
var DonateButton = /*#__PURE__*/styled(MuiButton)( /*#__PURE__*/_templateObject11$3());
var Loader = /*#__PURE__*/styled(CircularProgress)( /*#__PURE__*/_templateObject12$1());
var Error = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject13$1(), redText, tertiaryFont$4);
function DonateYourPointsDialog(_ref) {
  var option = _ref.option,
      isDonationDialogOpen = _ref.isDonationDialogOpen,
      setDonationDialogClosed = _ref.setDonationDialogClosed,
      setThanksDialogOpen = _ref.setThanksDialogOpen;

  var _useCustomerRewardsNe = useCustomerRewardsNetworkLayerValue(),
      pointsRedeemMutationLoading = _useCustomerRewardsNe.pointsRedeemMutationLoading,
      handlePointsRedeem = _useCustomerRewardsNe.handlePointsRedeem;

  var _React$useState = React__default.useState(null),
      error = _React$useState[0],
      setError = _React$useState[1];

  var dispatchHandlePointsRedeem = function dispatchHandlePointsRedeem() {
    try {
      var _temp2 = function () {
        if (!pointsRedeemMutationLoading && (option === null || option === void 0 ? void 0 : option.id)) {
          return Promise.resolve(handlePointsRedeem(option.id.toString())).then(function (response) {
            if (response === null || response === void 0 ? void 0 : response.success) {
              handleClose();
              setThanksDialogOpen();
            } else {
              var _response$error;

              // @ts-ignore
              setError(response === null || response === void 0 ? void 0 : (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.toString());
            }
          });
        }
      }();

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleClose = function handleClose() {
    setError(null);
    setDonationDialogClosed();
  };

  return React__default.createElement(Dialog, {
    open: isDonationDialogOpen,
    onClose: handleClose,
    scroll: "paper",
    disableBackdropClick: pointsRedeemMutationLoading,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, React__default.createElement(CloseButtonContainer, null, React__default.createElement(IconButton, {
    href: "",
    "aria-label": "close",
    onClick: handleClose
  }, React__default.createElement(CloseIcon, null))), React__default.createElement(Content, null, React__default.createElement(Header$2, null, "Donate Your Points"), React__default.createElement(Summary$1, null, "Help charitable organizations by donating your Reward Points!"), React__default.createElement(Container$2, null, React__default.createElement(Logo, {
    src: option === null || option === void 0 ? void 0 : option.icon,
    alt: option === null || option === void 0 ? void 0 : option.name
  }), React__default.createElement(PointsNeeded, null, numberWithCommas(option === null || option === void 0 ? void 0 : option.amount) || 0, " points"), React__default.createElement(Description, null, option === null || option === void 0 ? void 0 : option.name), React__default.createElement(DonateButton, {
    onClick: dispatchHandlePointsRedeem,
    type: "PRIMARY"
  }, pointsRedeemMutationLoading ? React__default.createElement(Loader, {
    size: 24
  }) : 'Donate'), error && React__default.createElement(Error, null, error))));
}

function _templateObject11$4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject11$4 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  padding-bottom: 40px;\n"]);

  _templateObject10$4 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$4() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    max-width: 256px !important;\n    @media all and (min-width: 768px) {\n      max-width: 288px !important;\n    }\n  }\n"]);

  _templateObject9$4 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  margin: 0 0 8px 0;\n  width: 232px;\n  color: ", ";\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: ", ";\n  color: ", ";\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  color: ", ";\n  padding-bottom: 40px;\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 32px;\n  line-height: 47px;\n  text-align: center;\n  letter-spacing: 0.03em;\n  font-family: ", ";\n  padding-bottom: 16px;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 16px 40px 16px;\n  font-family: ", ";\n  color: ", ";\n  @media all and (min-width: 768px) {\n    padding: 20px 80px 80px 80px;\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$4 = styles.cssConstants,
    tertiaryFont$5 = _s$cssConstants$4.tertiaryFont,
    italicFont$3 = _s$cssConstants$4.italicFont,
    black2$4 = _s$cssConstants$4.black2,
    neutral100$1 = _s$cssConstants$4.neutral100;
var StyledDialog$1 = /*#__PURE__*/withStyles({
  root: {
    textAlign: 'center',
    zIndex: "10002 !important"
  },
  paper: {
    maxWidth: '654px',
    borderRadius: '2px'
  },
  paperScrollPaper: {
    maxHeight: '100vh'
  }
})(MuiDialog);
var Content$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$6(), tertiaryFont$5, black2$4);
var Header$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$6(), italicFont$3);
var Summary$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$6(), black2$4);
var Dialog$1 = /*#__PURE__*/styled(StyledDialog$1)( /*#__PURE__*/_templateObject4$4(), tertiaryFont$5);
var CloseButtonContainer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$4());
var IconButton$1 = /*#__PURE__*/styled(MuiIconButton)( /*#__PURE__*/_templateObject6$4());
var Container$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$4(), tertiaryFont$5, black2$4);
var Description$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8$4(), neutral100$1);
var CloseButton = /*#__PURE__*/styled(MuiButton)( /*#__PURE__*/_templateObject9$4());
var PointsAmount$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject10$4());
var PointsText$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject11$4());
function ThankYouDialog(_ref) {
  var _option$name;

  var option = _ref.option,
      pointBalance = _ref.pointBalance,
      isThanksDialogOpen = _ref.isThanksDialogOpen,
      setThanksDialogClosed = _ref.setThanksDialogClosed;

  var handleClose = function handleClose() {
    setThanksDialogClosed();
  }; // const pointDollarAmount = getPointDollarAmount(pointBalance);


  return React__default.createElement(Dialog$1, {
    open: isThanksDialogOpen,
    onClose: handleClose,
    scroll: "paper",
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, React__default.createElement(CloseButtonContainer$1, null, React__default.createElement(IconButton$1, {
    href: "",
    "aria-label": "close",
    onClick: handleClose
  }, React__default.createElement(CloseIcon, null))), React__default.createElement(Content$1, null, React__default.createElement(Header$3, null, "Thank You!"), React__default.createElement(Summary$2, null, "You have successfully donated ", numberWithCommas(option === null || option === void 0 ? void 0 : option.amount) || 0, ' ', "of your Reward Points to ", option === null || option === void 0 ? void 0 : (_option$name = option.name) === null || _option$name === void 0 ? void 0 : _option$name.toLowerCase(), "!"), React__default.createElement(Container$3, null, React__default.createElement(Description$1, null, "Remaining Point Balance"), React__default.createElement(PointsAmount$1, null, numberWithCommas(pointBalance) || 0, ' ', React__default.createElement(PointsText$1, null, "points\xA0")), React__default.createElement(CloseButton, {
    onClick: handleClose,
    type: "PRIMARY"
  }, "Close"))));
}

function useToggle(initial) {
  if (initial === void 0) {
    initial = false;
  }

  var _useState = useState(initial),
      value = _useState[0],
      setToggle = _useState[1];

  return {
    value: value,
    set: setToggle,
    setTrue: function setTrue() {
      return setToggle(true);
    },
    setFalse: function setFalse() {
      return setToggle(false);
    },
    reset: function reset() {
      return setToggle(initial);
    },
    toggle: function toggle() {
      return setToggle(function (prev) {
        return !prev;
      });
    }
  };
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    width: 100%;\n  }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  text-align: center;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  margin: 16px 0 8px 0;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  height: 48px;\n  width: 232px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 8px;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 232px;\n  height: 232px;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: ", ";\n  color: ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$5 = styles.cssConstants,
    tertiaryFont$6 = _s$cssConstants$5.tertiaryFont,
    black2$5 = _s$cssConstants$5.black2;
var Container$4 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$7(), tertiaryFont$6, black2$5);
var Logo$1 = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject2$7());
var Description$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$7());
var PointsNeeded$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$5());
var DonateButton$1 = /*#__PURE__*/styled(MuiButton)( /*#__PURE__*/_templateObject5$5());
function DonationOption(props) {
  var option = props.option,
      pointBalance = props.pointBalance;
  var balance = pointBalance || 0;

  var _useToggle = useToggle(),
      isDonationDialogOpen = _useToggle.value,
      setDonationDialogOpen = _useToggle.setTrue,
      setDonationDialogClosed = _useToggle.setFalse;

  var _useToggle2 = useToggle(),
      isThanksDialogOpen = _useToggle2.value,
      setThanksDialogOpen = _useToggle2.setTrue,
      setThanksDialogClosed = _useToggle2.setFalse;

  var onDonationClick = function onDonationClick(e) {
    e.preventDefault();
    setDonationDialogOpen();
  };

  return createElement(Container$4, null, createElement(ThankYouDialog, {
    option: option,
    pointBalance: balance,
    isThanksDialogOpen: isThanksDialogOpen,
    setThanksDialogClosed: setThanksDialogClosed
  }), createElement(DonateYourPointsDialog, {
    option: option,
    setThanksDialogOpen: setThanksDialogOpen,
    isDonationDialogOpen: isDonationDialogOpen,
    setDonationDialogClosed: setDonationDialogClosed
  }), createElement(Logo$1, {
    src: option === null || option === void 0 ? void 0 : option.icon,
    alt: option === null || option === void 0 ? void 0 : option.name
  }), createElement(PointsNeeded$1, null, numberWithCommas(option === null || option === void 0 ? void 0 : option.amount) || 0, " points"), createElement(Description$2, null, option === null || option === void 0 ? void 0 : option.name), createElement(DonateButton$1, {
    onClick: onDonationClick,
    disabled: (option === null || option === void 0 ? void 0 : option.amount) ? balance < (option === null || option === void 0 ? void 0 : option.amount) : false,
    type: "GREY"
  }, "Donate"));
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  query GetDonationOptions {\n    viewer {\n      id\n      v2 {\n        id\n        yotpo {\n          id\n          donationRedemptionOptions {\n            edges {\n              node {\n                id\n                name\n                amount\n                cost_text\n                description\n                icon\n                duration\n                discount_type\n                discount_amount_cents\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var GET_DONATION_OPTIONS_QUERY = /*#__PURE__*/gql( /*#__PURE__*/_templateObject$8());

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid !important;\n  grid-template-columns: repeat(\n    ", ",\n    232px\n  ) !important;\n  grid-gap: 32px !important;\n  justify-content: center !important;\n  padding: 0 !important;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    .slick-slider {\n      position: relative;\n\n      display: block;\n      box-sizing: border-box;\n\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n\n      -webkit-touch-callout: none;\n      -ms-touch-action: pan-y;\n      touch-action: pan-y;\n      -webkit-tap-highlight-color: transparent;\n      :hover {\n        cursor: pointer;\n      }\n    }\n\n    .slick-list {\n      position: relative;\n\n      display: block;\n      overflow: hidden;\n      margin: 0;\n      padding: 0;\n      height: 370px;\n      max-width: 232px;\n      @media all and (min-width: 768px) {\n        max-width: 760px;\n      }\n      *:focus {\n        outline: 0;\n        outline: none;\n      }\n    }\n\n    .slick-list:focus {\n      outline: none;\n    }\n    .slick-list.dragging {\n      cursor: pointer;\n    }\n\n    .slick-slider .slick-track,\n    .slick-slider .slick-list {\n      -webkit-transform: translate3d(0, 0, 0);\n      -moz-transform: translate3d(0, 0, 0);\n      -ms-transform: translate3d(0, 0, 0);\n      -o-transform: translate3d(0, 0, 0);\n      transform: translate3d(0, 0, 0);\n    }\n\n    .slick-track {\n      position: relative;\n      top: 0;\n      left: 0;\n\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .slick-track:before,\n    .slick-track:after {\n      display: table;\n\n      content: '';\n    }\n    .slick-track:after {\n      clear: both;\n    }\n    .slick-loading .slick-track {\n      visibility: hidden;\n    }\n\n    .slick-slide {\n      //display: none;\n      float: left;\n\n      height: 100%;\n      min-height: 1px;\n      //width: 288px;\n      //margin: 0 12px;\n    }\n    [dir='rtl'] .slick-slide {\n      float: right;\n    }\n    .slick-slide img {\n      display: block;\n    }\n    .slick-slide.slick-loading img {\n      display: none;\n    }\n    .slick-slide.dragging img {\n      pointer-events: none;\n    }\n    .slick-initialized .slick-slide {\n      display: block;\n    }\n    .slick-loading .slick-slide {\n      visibility: hidden;\n    }\n    .slick-vertical .slick-slide {\n      display: block;\n\n      height: auto;\n\n      border: 1px solid transparent;\n    }\n    .slick-arrow.slick-hidden {\n      display: none;\n    }\n\n    .slick-prev,\n    .slick-next {\n      font-size: 0;\n      line-height: 0;\n\n      position: absolute;\n      top: 50%;\n\n      display: block;\n\n      width: 20px;\n      height: 20px;\n      padding: 0;\n      -webkit-transform: translate(0, -50%);\n      -ms-transform: translate(0, -50%);\n      transform: translate(0, -50%);\n\n      cursor: pointer;\n\n      color: transparent;\n      border: none;\n      outline: none;\n      background: transparent;\n    }\n    .slick-prev:hover,\n    .slick-prev:focus,\n    .slick-next:hover,\n    .slick-next:focus {\n      color: transparent;\n      outline: none;\n      background: transparent;\n    }\n    .slick-prev:hover:before,\n    .slick-prev:focus:before,\n    .slick-next:hover:before,\n    .slick-next:focus:before {\n      opacity: 1;\n    }\n    .slick-prev.slick-disabled:before,\n    .slick-next.slick-disabled:before {\n      opacity: 0.25;\n    }\n\n    .slick-prev:before,\n    .slick-next:before {\n      font-size: 20px;\n      line-height: 1;\n\n      opacity: 0.75;\n      color: white;\n\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n\n    .slick-prev {\n      left: -25px;\n    }\n    [dir='rtl'] .slick-prev {\n      right: -25px;\n      left: auto;\n    }\n    .slick-prev:before {\n      content: '\u2190';\n    }\n    [dir='rtl'] .slick-prev:before {\n      content: '\u2192';\n    }\n\n    .slick-next {\n      right: -25px;\n    }\n    [dir='rtl'] .slick-next {\n      right: auto;\n      left: -25px;\n    }\n    .slick-next:before {\n      content: '\u2192';\n    }\n    [dir='rtl'] .slick-next:before {\n      content: '\u2190';\n    }\n\n    /* Dots */\n    .slick-dotted.slick-slider {\n      margin-bottom: 30px;\n    }\n\n    .slick-dots {\n      height: 8px;\n      bottom: unset;\n      width: 100%;\n      padding: 0 0 16px 0;\n      margin: 24px auto 136px auto;\n      list-style: none;\n      text-align: center;\n      max-width: 100%;\n      left: 50%;\n      position: absolute;\n      transform: translate(-50%, 0);\n      @media only screen and (min-width: 768px) {\n        max-width: 100%;\n        padding: 0;\n        margin: 24px auto 0 auto;\n      }\n    }\n    .slick-dots li {\n      position: relative;\n\n      display: inline-block;\n\n      margin: 32px 8px 0 8px;\n      padding: 0;\n\n      cursor: pointer;\n    }\n    .slick-dots li button {\n      font-size: 0;\n      line-height: 0;\n\n      display: block;\n\n      padding: 5px;\n\n      cursor: pointer;\n\n      color: transparent;\n      border: 0;\n      outline: none;\n      background: transparent;\n    }\n    .slick-dots li button:hover,\n    .slick-dots li button:focus {\n      outline: none;\n    }\n    .slick-dots li button:hover:before,\n    .slick-dots li button:focus:before {\n      opacity: 1;\n    }\n    .slick-dots li button:before {\n      font-size: 6px;\n      line-height: 20px;\n\n      position: absolute;\n      top: 0;\n      left: 0;\n\n      width: 8px;\n      height: 8px;\n      content: '';\n\n      text-align: center;\n\n      background-color: white;\n      border: 1px solid black;\n      border-radius: 100%;\n\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n    .slick-dots li.slick-active button:before,\n    .slick-dots li.slick-active,\n    .slick-dots li.slick-active button {\n      background-color: black;\n      border-radius: 100%;\n    }\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Carousel = /*#__PURE__*/styled(SlickCarousel)( /*#__PURE__*/_templateObject$9());
var Grid = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$8(), function (props) {
  return props.rowcount;
});

function makeGrid(items, itemsPerRow) {
  if (itemsPerRow === void 0) {
    itemsPerRow = 1;
  }

  var gridItems = [];
  var numberOfRows = Math.ceil((items === null || items === void 0 ? void 0 : items.length) / itemsPerRow);

  for (var i = 0; i < numberOfRows; i++) {
    var offset = i * itemsPerRow;
    var rowItems = items.slice(offset, offset + itemsPerRow);
    var rowCount = Math.min(rowItems === null || rowItems === void 0 ? void 0 : rowItems.length, itemsPerRow);
    gridItems.push(React__default.createElement(Grid, {
      key: i,
      rowcount: rowCount
    }, rowItems));
  }

  return gridItems;
}

var settings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0
};
var MAX_SLIDES = 12;
var DonationOptionsCarousel = (function (_ref) {
  var children = _ref.children;
  if (!children) return null;
  var isMobile = useMediaQuery('(max-width:767px)', {
    noSsr: true
  });
  var slidedToShow = isMobile ? 1 : 3;
  return React__default.createElement(Carousel, Object.assign({}, settings), makeGrid(children === null || children === void 0 ? void 0 : children.slice(0, MAX_SLIDES * slidedToShow), slidedToShow));
});

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  //display: flex;\n  //align-items: flex-start;\n  //height: 370px;\n  margin-bottom: 40px;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
//   cssConstants: { italicFont },
// } = s;

var Container$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$a());
function DonationOptions(props) {
  var _data$viewer, _data$viewer$v, _data$viewer$v$yotpo, _data$viewer$v$yotpo$;

  var _useCustomerRewardsNe = useCustomerRewardsNetworkLayerValue(),
      apolloClient = _useCustomerRewardsNe.apolloClient;

  var queryOptions = {
    client: apolloClient
  };

  var _useQuery = useQuery(GET_DONATION_OPTIONS_QUERY, queryOptions),
      data = _useQuery.data,
      loading = _useQuery.loading;

  if (loading) return null;
  var donationOptions = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$v = _data$viewer.v2) === null || _data$viewer$v === void 0 ? void 0 : (_data$viewer$v$yotpo = _data$viewer$v.yotpo) === null || _data$viewer$v$yotpo === void 0 ? void 0 : (_data$viewer$v$yotpo$ = _data$viewer$v$yotpo.donationRedemptionOptions) === null || _data$viewer$v$yotpo$ === void 0 ? void 0 : _data$viewer$v$yotpo$.edges;
  return createElement(Container$5, null, createElement(DonationOptionsCarousel, null, donationOptions === null || donationOptions === void 0 ? void 0 : donationOptions.map(function (option) {
    var _option$node;

    return createElement(DonationOption, {
      pointBalance: props.pointBalance,
      option: option === null || option === void 0 ? void 0 : option.node,
      key: option === null || option === void 0 ? void 0 : (_option$node = option.node) === null || _option$node === void 0 ? void 0 : _option$node.id
    });
  })));
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 32px;\n  line-height: 47px;\n  text-align: center;\n  letter-spacing: 0.03em;\n  padding-bottom: 32px;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  background: white;\n  padding-bottom: 40px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 64px;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var italicFont$4 = styles.cssConstants.italicFont;
var Wrapper$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$b());
var Container$6 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$9());
var Header$4 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$8(), italicFont$4);
function DonationOptionsWrapper(props) {
  return createElement(Wrapper$3, null, createElement(Container$6, null, createElement(Header$4, null, "Donate Your Points"), createElement(DonationOptions, {
    pointBalance: props.pointBalance
  })));
}

function CustomerRewards(_ref) {
  var _viewer$user, _viewer$v, _viewer$v$yotpo, _viewer$v$yotpo$user, _viewer$user2;

  var viewer = _ref.viewer,
      shopUrl = _ref.shopUrl,
      handlePointsRedeem = _ref.handlePointsRedeem,
      apolloClient = _ref.apolloClient,
      pointsRedeemMutationLoading = _ref.pointsRedeemMutationLoading;
  return createElement(CustomerRewardsNetworkLayer, {
    viewer: viewer,
    shopUrl: shopUrl,
    apolloClient: apolloClient,
    handlePointsRedeem: handlePointsRedeem,
    pointsRedeemMutationLoading: pointsRedeemMutationLoading
  }, createElement(CustomerRewardsProvider, null, createElement(RewardsSummary, {
    pointBalance: viewer === null || viewer === void 0 ? void 0 : (_viewer$user = viewer.user) === null || _viewer$user === void 0 ? void 0 : _viewer$user.pointBalance
  }), createElement(PointsActivityTable, {
    historyItems: viewer === null || viewer === void 0 ? void 0 : (_viewer$v = viewer.v2) === null || _viewer$v === void 0 ? void 0 : (_viewer$v$yotpo = _viewer$v.yotpo) === null || _viewer$v$yotpo === void 0 ? void 0 : (_viewer$v$yotpo$user = _viewer$v$yotpo.user) === null || _viewer$v$yotpo$user === void 0 ? void 0 : _viewer$v$yotpo$user.historyItems
  }), createElement(DonationOptionsWrapper, {
    pointBalance: viewer === null || viewer === void 0 ? void 0 : (_viewer$user2 = viewer.user) === null || _viewer$user2 === void 0 ? void 0 : _viewer$user2.pointBalance
  })));
}

var POINTS_MULTIPLIER = 100;

function convertDollarAmountToPoints(amount) {
  var amountString = amount ? amount.toString() : '';
  return amountString ? Math.round(parseFloat(amountString.replace(/,/g, '')) * POINTS_MULTIPLIER) : 0;
}
function getPromoCode(cart) {
  var _cart$promoCodes;

  return (cart === null || cart === void 0 ? void 0 : cart.promoCodes) && (cart === null || cart === void 0 ? void 0 : (_cart$promoCodes = cart.promoCodes) === null || _cart$promoCodes === void 0 ? void 0 : _cart$promoCodes.length) > 0 ? cart === null || cart === void 0 ? void 0 : cart.promoCodes[0] : null;
}
function getGiftCards(cart) {
  var _cart$wordPressCoupon;

  return (cart === null || cart === void 0 ? void 0 : cart.wordPressCoupons) && (cart === null || cart === void 0 ? void 0 : (_cart$wordPressCoupon = cart.wordPressCoupons) === null || _cart$wordPressCoupon === void 0 ? void 0 : _cart$wordPressCoupon.length) > 0 ? cart === null || cart === void 0 ? void 0 : cart.wordPressCoupons : [];
}
function getRewardsCoupon(cart) {
  var _cart$wordPressCoupon2;

  if ((cart === null || cart === void 0 ? void 0 : cart.wordPressCoupons) && (cart === null || cart === void 0 ? void 0 : (_cart$wordPressCoupon2 = cart.wordPressCoupons) === null || _cart$wordPressCoupon2 === void 0 ? void 0 : _cart$wordPressCoupon2.length) > 0) {
    var filteredGiftCards = cart === null || cart === void 0 ? void 0 : cart.wordPressCoupons.filter(function (card) {
      return !!(card === null || card === void 0 ? void 0 : card.yotpoCouponCode);
    });
    if (filteredGiftCards && filteredGiftCards.length > 0) return filteredGiftCards[0];
  }

  return null;
}
function getFormattedPromoCode(promo) {
  var _promo$code, _promo$code$toUpperCa;

  return (promo === null || promo === void 0 ? void 0 : (_promo$code = promo.code) === null || _promo$code === void 0 ? void 0 : (_promo$code$toUpperCa = _promo$code.toUpperCase()) === null || _promo$code$toUpperCa === void 0 ? void 0 : _promo$code$toUpperCa.replace('GRAPEFULCLUB', 'PREFERREDCUSTOMER')) || '';
}
function isGuest(user) {
  var _user$userId;

  return !(user === null || user === void 0 ? void 0 : user.userId) || (user === null || user === void 0 ? void 0 : user.userId) && (user === null || user === void 0 ? void 0 : (_user$userId = user.userId) === null || _user$userId === void 0 ? void 0 : _user$userId.includes('.'));
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-weight: normal;\n  line-height: 1.57;\n  font-size: 12px;\n  color: ", ";\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  & .MuiInputBase-input {\n    font-family: ", ";\n    height: 41.82px;\n    -webkit-appearance: none !important;\n    padding: ", ";\n    font-weight: normal;\n    line-height: 1.57;\n    font-size: 12px;\n    background-color: ", ";\n    border: ", ";\n    border-radius: 2px 0 0 2px;\n  }\n  & .MuiInput-underline:before {\n    border-bottom: none !important;\n  }\n  & .MuiInput-underline:hover:before {\n    border-bottom: none !important;\n  }\n  & .MuiInput-underline:after {\n    border-bottom: none !important;\n  }\n  & .MuiFormHelperText-root {\n    font-family: ", ";\n    font-size: 11px;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.64;\n    letter-spacing: normal;\n    margin-top: 8px;\n  }\n  & .MuiFormHelperText-root.Mui-error {\n    color: ", ";\n  }\n  & .MuiInputAdornment-positionEnd {\n    position: absolute;\n    right: 16px;\n  }\n  & .MuiInputAdornment-positionStart {\n    position: absolute;\n    left: 16px;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$6 = styles.cssConstants,
    tertiaryFont$7 = _s$cssConstants$6.tertiaryFont,
    neutral5$2 = _s$cssConstants$6.neutral5,
    errorColor = _s$cssConstants$6.errorColor,
    neutral0 = _s$cssConstants$6.neutral0,
    textColor = _s$cssConstants$6.textColor,
    neutral100$2 = _s$cssConstants$6.neutral100; // @ts-ignore: Type 'CreateStyled<any>' has no call signatures

var Input = /*#__PURE__*/styled(TextField)( /*#__PURE__*/_templateObject$c(), tertiaryFont$7, function (_ref) {
  var startAdornment = _ref.startAdornment;
  return startAdornment ? '0.15rem 16px 0.15em 34px' : '0.15rem 16px';
}, function (_ref2) {
  var hasSuccess = _ref2.hasSuccess,
      error = _ref2.error;
  return hasSuccess ? neutral0 : error ? '#FDF6F5' : neutral5$2;
}, function (_ref3) {
  var hasSuccess = _ref3.hasSuccess,
      error = _ref3.error;
  return hasSuccess ? "1px solid " + neutral0 : error ? "1px solid " + errorColor : "1px solid " + neutral5$2;
}, tertiaryFont$7, textColor);
var EndAdornment = /*#__PURE__*/styled(InputAdornment)( /*#__PURE__*/_templateObject2$a(), tertiaryFont$7, neutral100$2);

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    width: 72px !important;\n    height: 48px !important;\n    border-radius: 0 2px 2px 0 !important;\n  }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    -webkit-appearance: none !important;\n    width: 100%;\n    max-width: 218px;\n    @media all and (min-width: 768px) {\n      max-width: 362px;\n    }\n  }\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiCircularProgress-colorPrimary {\n    color: white;\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 16px;\n  justify-content: center;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var Container$7 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$d());
var Loader$1 = /*#__PURE__*/styled(CircularProgress)( /*#__PURE__*/_templateObject2$b());
var MuiInput = /*#__PURE__*/styled(Input)( /*#__PURE__*/_templateObject3$9());
var Button = /*#__PURE__*/styled(MuiButton)( /*#__PURE__*/_templateObject4$6());
function InputContainer(props) {
  var mask = props.mask,
      onApply = props.onApply,
      disabled = props.disabled,
      cartPromoCodeUpdateMutationLoading = props.cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading = props.applyRewardsToCartMutationLoading,
      rest = _objectWithoutPropertiesLoose(props, ["validate", "hasError", "hasSuccess", "mask", "onApply", "disabled", "name", "cartPromoCodeUpdateMutationLoading", "applyRewardsToCartMutationLoading"]);

  var maskInput = mask ? {
    inputComponent: mask,
    value: props.value,
    onChange: props.onChange
  } : {};

  var getAdornment = function getAdornment() {
    return _extends({
      startAdornment: props === null || props === void 0 ? void 0 : props.startAdornment,
      endAdornment: React__default.createElement(EndAdornment, {
        position: "end"
      }, " ", props === null || props === void 0 ? void 0 : props.endAdornment)
    }, maskInput);
  };

  var handleOnApply = function handleOnApply() {
    if (!cartPromoCodeUpdateMutationLoading && !applyRewardsToCartMutationLoading) {
      onApply();
    }
  };

  return React__default.createElement(Container$7, null, React__default.createElement(MuiInput, Object.assign({
    InputProps: getAdornment()
  }, rest)), React__default.createElement(Button // @ts-ignore
  , {
    // @ts-ignore
    type: "PRIMARY",
    onClick: handleOnApply,
    disabled: disabled || !(props === null || props === void 0 ? void 0 : props.value)
  }, applyRewardsToCartMutationLoading ? React__default.createElement(Loader$1, {
    size: 24
  }) : 'apply'));
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 4px;\n  height: 18px;\n  cursor: pointer;\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 8px;\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  /* font-weight: 500; */\n  font-size: 12px;\n  line-height: 18px;\n  padding-bottom: 16px;\n  color: #997963;\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  /* font-weight: 500; */\n  font-size: 12px;\n  line-height: 18px;\n  padding-bottom: 16px;\n  color: #997963;\n  margin-right: 4px;\n  color: ", ";\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  color: ", ";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 18px;\n  text-decoration-line: underline;\n  cursor: pointer;\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  height: 22px;\n  margin: ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$7 = styles$1.cssConstants,
    tertiaryFont$8 = _s$cssConstants$7.tertiaryFont,
    textColor$1 = _s$cssConstants$7.textColor;
var Container$8 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$e(), function (_ref) {
  var isModal = _ref.isModal;
  return isModal ? '0px 0 16px' : '8px 0 0';
});
var Remove = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$c(), tertiaryFont$8, textColor$1);
var Summary$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$a());
var Title = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$7(), tertiaryFont$8, textColor$1);
var Savings = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$6(), tertiaryFont$8);
var IconContainer = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject6$5());
var DeleteIcon = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$5());
function AppliedSavings(props) {
  var name = props.name,
      savings = props.savings,
      handleRemove = props.handleRemove,
      isModal = props.isModal,
      isBulkOrderDiscount = props.isBulkOrderDiscount;
  if (!name) return null;
  return React__default.createElement(Container$8, {
    isModal: isModal
  }, React__default.createElement(Summary$3, null, React__default.createElement(IconContainer, null, (props === null || props === void 0 ? void 0 : props.isPromoCode) && React__default.createElement(SvgTag, null), (props === null || props === void 0 ? void 0 : props.isGiftCard) && React__default.createElement(SvgGift, null), (props === null || props === void 0 ? void 0 : props.isRewards) && React__default.createElement(SvgRewards, null)), React__default.createElement(Title, null, name, " "), isModal ? React__default.createElement(Savings, null, "(-", React__default.createElement(Currency, {
    rawValue: savings
  }), ")") : React__default.createElement(DeleteIcon, null, !isBulkOrderDiscount && React__default.createElement(SvgDelete, {
    onClick: handleRemove
  }))), isModal ? React__default.createElement(Remove, {
    onClick: handleRemove
  }, "Remove") : React__default.createElement(Savings, null, "(-", React__default.createElement(Currency, {
    rawValue: savings
  }), ")"));
}

var defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false
};
function CurrencyMask(props) {
  var currencyMask = createNumberMask(_extends({}, defaultMaskOptions));
  return React__default.createElement(ReactMuiMask, Object.assign({
    mask: currencyMask
  }, props));
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0;\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n  @media all and (min-width: 768px) {\n    padding: 0 72px;\n  }\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 40px;\n\n  /* font-family: Brandon Grotesque; */\n  font-family: ", ";\n  /* font-weight: 500; */\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 21px;\n  padding-bottom: 16px;\n\n  div:first-of-type {\n    font-weight: normal;\n    margin-right: 3px;\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n  /* font-family: Brandon Grotesque; */\n  font-family: ", ";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  /* identical to box height, or 150% */\n  letter-spacing: 0.01em;\n  text-align: center;\n  padding-bottom: 24px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 40px;\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 40px;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  max-width: 288px;\n  @media all and (min-width: 768px) {\n    padding-top: 0;\n    margin: 40px 64px;\n    min-width: 432px;\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var tertiaryFont$9 = styles.cssConstants.tertiaryFont;
var Container$9 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$f());
var Header$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$d(), tertiaryFont$9);
var Close = /*#__PURE__*/styled(SvgClose)( /*#__PURE__*/_templateObject3$b());
var AvailableRewards = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$8(), tertiaryFont$9);
var ButtonContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$7());
var FormContainer = /*#__PURE__*/styled(Form)( /*#__PURE__*/_templateObject6$6());
var promoCodeAdornment = /*#__PURE__*/React__default.createElement(InputAdornment, {
  position: "start"
}, /*#__PURE__*/React__default.createElement(SvgPlus, null));
var rewardsAdornment = /*#__PURE__*/React__default.createElement(InputAdornment, {
  position: "start"
}, /*#__PURE__*/React__default.createElement(SvgDollar, null));
var PromoCodeValidationSchema = /*#__PURE__*/object().shape({
  promoCode: /*#__PURE__*/string()
});
var RewardsValidationSchema = /*#__PURE__*/object().shape({
  rewardAmount: /*#__PURE__*/string()
});
function DialogContent(props) {
  var _user$conciergeUser;

  var user = props.user,
      cart = props.cart,
      handleClose = props.handleClose,
      handlePromoCodeAdd = props.handlePromoCodeAdd,
      handlePromoCodeRemove = props.handlePromoCodeRemove,
      handleRewardPointsAdd = props.handleRewardPointsAdd,
      applyRewardsToCartMutationLoading = props.applyRewardsToCartMutationLoading,
      cartPromoCodeUpdateMutationLoading = props.cartPromoCodeUpdateMutationLoading;
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  var promo = getPromoCode(cart);
  var promoCode = promo ? getFormattedPromoCode(promo) : '';
  var savings = cart === null || cart === void 0 ? void 0 : cart.promoCodeSavings; //getPromoCodeSavings(cart);

  var giftCards = getGiftCards(cart); // const wordPressCouponSavings = cart?.wordPressCouponSavings;

  var coupon = getRewardsCoupon(cart);
  var rewardAmount = (coupon === null || coupon === void 0 ? void 0 : coupon.storeBalance) || 0; // if in concierge mode, user from checkout is the customer & should have a
  // shoppingWithCeoUser, otherwise user from cart is the CE & should have a conciergeUser

  var isConciergeUser = !!(user === null || user === void 0 ? void 0 : user.conciergeUser) || !!(user === null || user === void 0 ? void 0 : user.shoppingWithCeoUser);
  var rewardsUser = (_user$conciergeUser = user === null || user === void 0 ? void 0 : user.conciergeUser) !== null && _user$conciergeUser !== void 0 ? _user$conciergeUser : user;
  var pointBalance = (rewardsUser === null || rewardsUser === void 0 ? void 0 : rewardsUser.pointBalance) || 0;
  var pointDollarAmount = getPointDollarAmount(pointBalance);
  var isGuestAccount = isGuest(user);
  var title = isGuestAccount ? 'Promo Codes and Gift Cards' : 'Promos, Gift Cards, and Rewards';

  var handleOnSubmitPromoCode = function handleOnSubmitPromoCode(values, _ref) {
    var setErrors = _ref.setErrors,
        resetForm = _ref.resetForm;
    var promoCode = values.promoCode;

    if (!cartPromoCodeUpdateMutationLoading && !applyRewardsToCartMutationLoading) {
      handlePromoCodeAdd(promoCode, setErrors, resetForm);
    }
  };

  var handleOnSubmitRewards = function handleOnSubmitRewards(values, _ref2) {
    var setErrors = _ref2.setErrors,
        resetForm = _ref2.resetForm;
    var rewardAmount = values.rewardAmount;
    var amount = parseFloat(rewardAmount.replace(/,/g, ''));
    var points = convertDollarAmountToPoints(amount);
    handleRewardPointsAdd(points, setErrors, resetForm);
  };

  var removeRewards = function removeRewards() {
    if (coupon) {
      handlePromoCodeRemove(coupon);
    }
  };

  return React__default.createElement(Container$9, null, React__default.createElement(Close, {
    onClick: handleClose
  }), React__default.createElement(Header$5, null, title), React__default.createElement(Formik, {
    initialValues: {
      promoCode: ''
    },
    validateOnChange: true,
    validationSchema: PromoCodeValidationSchema,
    onSubmit: handleOnSubmitPromoCode
  }, function (_ref3) {
    var errors = _ref3.errors,
        touched = _ref3.touched,
        values = _ref3.values,
        handleChange = _ref3.handleChange,
        setFieldTouched = _ref3.setFieldTouched,
        handleSubmit = _ref3.handleSubmit,
        setErrors = _ref3.setErrors;

    var removePromoCode = function removePromoCode() {
      if (promo) {
        handlePromoCodeRemove(promo, setErrors);
      } // because of PC dialog, reset errors now instead of
      // after mutation
      // if (promo?.code === 'GRAPEFULCLUB') {
      //   setErrors({});
      // }

    };

    var change = function change(name, e) {
      e.persist();
      handleChange(e);
      setFieldTouched(name, true, false);
    };

    var hasErrors = touched.promoCode && Boolean(errors.promoCode);
    return React__default.createElement("div", null, React__default.createElement(FormContainer, null, React__default.createElement(InputContainer, {
      placeholder: "Enter promo code or gift card",
      id: "promoCode",
      name: "promoCode",
      fullWidth: true,
      validate: true,
      cartPromoCodeUpdateMutationLoading: cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading: false,
      value: values.promoCode && values.promoCode,
      error: hasErrors,
      helperText: touched.promoCode && errors.promoCode,
      hasError: hasErrors,
      hasSuccess: !Boolean(errors.promoCode),

      /* eslint-disable react/jsx-no-bind */
      onChange: function onChange(e) {
        return change('promoCode', e);
      },
      onApply: handleSubmit,
      disabled: isEmpty(touched) || hasErrors,
      startAdornment: promoCodeAdornment
    })), promo && React__default.createElement(AppliedSavings, {
      isPromoCode: true,
      isModal: true,
      name: promoCode,
      savings: savings,
      handleRemove: removePromoCode
    }));
  }), giftCards && giftCards.length ? giftCards.map(function (card, index) {
    if (!(card === null || card === void 0 ? void 0 : card.yotpoCouponCode)) {
      var _card$code;

      var name = (_card$code = card === null || card === void 0 ? void 0 : card.code) !== null && _card$code !== void 0 ? _card$code : '';

      var removeGiftCard = function removeGiftCard() {
        if (card) {
          handlePromoCodeRemove(card);
        }
      };

      return React__default.createElement(AppliedSavings, {
        isGiftCard: true,
        isModal: true,
        name: name,
        key: "" + index + (card === null || card === void 0 ? void 0 : card.code),
        savings: (card === null || card === void 0 ? void 0 : card.storeBalance) || 0,
        handleRemove: removeGiftCard
      });
    }

    return null;
  }) : null, !isGuestAccount && React__default.createElement("div", null, React__default.createElement(AvailableRewards, null, React__default.createElement("div", null, isConciergeUser ? (rewardsUser === null || rewardsUser === void 0 ? void 0 : rewardsUser.firstName) + "'s" : '', " Available Rewards Credit:", ' '), React__default.createElement("div", null, "$", pointDollarAmount.toFixed(2), " (", numberWithCommas(pointBalance) || 0, " points)")), React__default.createElement(Formik, {
    initialValues: {
      rewardAmount: ''
    },
    validateOnChange: true,
    validationSchema: RewardsValidationSchema,
    onSubmit: handleOnSubmitRewards
  }, function (_ref4) {
    var errors = _ref4.errors,
        touched = _ref4.touched,
        values = _ref4.values,
        handleChange = _ref4.handleChange,
        setFieldTouched = _ref4.setFieldTouched,
        handleSubmit = _ref4.handleSubmit;

    var change = function change(name, e) {
      e.persist();
      handleChange(e);
      setFieldTouched(name, true, false);
    };

    var amount = parseFloat(values === null || values === void 0 ? void 0 : values.rewardAmount.replace(/,/g, ''));
    var pointsAdornment = numberWithCommas(convertDollarAmountToPoints(amount)) || 0;
    var hasErrors = touched.rewardAmount && Boolean(errors.rewardAmount);
    return React__default.createElement(FormContainer, null, React__default.createElement(InputContainer, {
      placeholder: isMobile ? 'Rewards amount' : 'Enter rewards amount',
      id: "rewardAmount",
      name: "rewardAmount",
      fullWidth: true,
      validate: true,
      cartPromoCodeUpdateMutationLoading: false,
      applyRewardsToCartMutationLoading: applyRewardsToCartMutationLoading || cartPromoCodeUpdateMutationLoading,
      value: values.rewardAmount && values.rewardAmount,
      error: hasErrors,
      helperText: touched.rewardAmount && errors.rewardAmount,
      hasError: hasErrors,
      hasSuccess: !Boolean(errors.rewardAmount),

      /* eslint-disable react/jsx-no-bind */
      onChange: function onChange(e) {
        return change('rewardAmount', e);
      },
      onApply: handleSubmit,
      disabled: isEmpty(touched) || hasErrors,
      startAdornment: rewardsAdornment,
      endAdornment: "(" + pointsAdornment + " points)",
      mask: CurrencyMask
    }));
  }), coupon && React__default.createElement(AppliedSavings, {
    isRewards: true,
    isModal: true,
    name: "Reward points",
    savings: rewardAmount,
    handleRemove: removeRewards
  })), React__default.createElement(ButtonContainer, null, React__default.createElement(MuiButton // @ts-ignore
  , {
    // @ts-ignore
    type: "PRIMARY",
    onClick: handleClose
  }, "save and continue")));
}

var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  // @ts-ignore: Type 'string' is not assignable to type 'ReactElement<any, any>'
  return React__default.createElement(Slide, Object.assign({
    direction: "left",
    ref: ref
  }, props));
});

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 8px;\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  height: 40px;\n\n  div {\n    /* font-family: Brandon Grotesque; */\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    color: ", ";\n  }\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n   margin-right: -16px;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  &.MuiDialog-root {\n    z-index: 10002 !important;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var _s$cssConstants$8 = styles.cssConstants,
    tertiaryFont$a = _s$cssConstants$8.tertiaryFont,
    primaryColor = _s$cssConstants$8.primaryColor;
var DialogContainer = /*#__PURE__*/styled(MuiDialog)( /*#__PURE__*/_templateObject$g());
var SvgCarrot = /*#__PURE__*/styled(SvgRight)( /*#__PURE__*/_templateObject2$e());
var HeaderContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$c(), tertiaryFont$a, primaryColor);
var SavingsContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$9());
function Discount(props) {
  var cartPromoCodeUpdateMutationLoading = props.cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading = props.applyRewardsToCartMutationLoading,
      handlePromoCodeAdd = props.handlePromoCodeAdd,
      handlePromoCodeRemove = props.handlePromoCodeRemove,
      handleRewardPointsAdd = props.handleRewardPointsAdd,
      user = props.user,
      cart = props.cart;

  var _useToggle = useToggle(),
      isOpen = _useToggle.value,
      handleOpen = _useToggle.setTrue,
      handleClose = _useToggle.setFalse;

  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  var saleSavings = cart === null || cart === void 0 ? void 0 : cart.saleSavings;
  var promo = getPromoCode(cart);
  var savings = cart === null || cart === void 0 ? void 0 : cart.promoCodeSavings; //getPromoCodeSavings(cart);

  var giftCards = getGiftCards(cart); // const wordPressCouponSavings = cart?.wordPressCouponSavings;

  var coupon = getRewardsCoupon(cart);
  var rewardAmount = (coupon === null || coupon === void 0 ? void 0 : coupon.storeBalance) || 0;
  var rewardPointsApplied = numberWithCommas(convertDollarAmountToPoints(rewardAmount));
  var hasSavings = promo || savings || saleSavings || giftCards && giftCards.length || !!rewardAmount && rewardPointsApplied;

  var removePromoCode = function removePromoCode() {
    if (promo) {
      handlePromoCodeRemove(promo);
    }
  };

  var removeRewards = function removeRewards() {
    if (coupon) {
      handlePromoCodeRemove(coupon);
    }
  };

  var isGuestAccount = isGuest(user);
  var title = isGuestAccount ? 'Promo code or gift card' : 'Promo code, gift card or rewards';
  return React__default.createElement("div", null, React__default.createElement(HeaderContainer, {
    onClick: handleOpen
  }, React__default.createElement("div", null, title), React__default.createElement(SvgCarrot, null)), hasSavings && React__default.createElement(SavingsContainer, null, saleSavings > 0 && React__default.createElement(AppliedSavings, {
    isPromoCode: true,
    isBulkOrderDiscount: true,
    name: "Sale discounts",
    savings: saleSavings,
    handleRemove: function handleRemove() {}
  }), savings > 0 && React__default.createElement(AppliedSavings, {
    isPromoCode: true,
    isBulkOrderDiscount: !!!promo,
    name: promo ? (promo === null || promo === void 0 ? void 0 : promo.code) + " promo code" : "Bulk order discounts",
    savings: savings,
    handleRemove: removePromoCode
  }), giftCards && giftCards.length ? giftCards.map(function (card, index) {
    if (!(card === null || card === void 0 ? void 0 : card.yotpoCouponCode)) {
      var removeGiftCard = function removeGiftCard() {
        if (card) {
          handlePromoCodeRemove(card);
        }
      };

      return React__default.createElement(AppliedSavings, {
        isGiftCard: true,
        key: "" + index + (card === null || card === void 0 ? void 0 : card.code),
        name: "Gift card",
        savings: (card === null || card === void 0 ? void 0 : card.storeBalance) || 0,
        handleRemove: removeGiftCard
      });
    }

    return null;
  }) : null, !!rewardAmount && rewardPointsApplied && React__default.createElement(AppliedSavings, {
    isRewards: true,
    name: "Reward points (" + rewardPointsApplied + ")",
    savings: rewardAmount,
    handleRemove: removeRewards
  })), React__default.createElement(DialogContainer, {
    open: isOpen,
    onClose: handleClose,
    fullScreen: isMobile,
    disableEnforceFocus: true,
    TransitionComponent: isMobile ? Transition : Fade
  }, React__default.createElement(DialogContent, {
    user: user,
    cart: cart,
    handleClose: handleClose,
    handlePromoCodeAdd: handlePromoCodeAdd,
    handlePromoCodeRemove: handlePromoCodeRemove,
    handleRewardPointsAdd: handleRewardPointsAdd,
    cartPromoCodeUpdateMutationLoading: cartPromoCodeUpdateMutationLoading,
    applyRewardsToCartMutationLoading: applyRewardsToCartMutationLoading
  })));
}

export { CustomerRewards, Discount };
//# sourceMappingURL=customer-rewards.esm.js.map
